import { flashItems } from '@/mocks/home';

const tagStyles: Record<string, string> = {
  热议: 'bg-primary-100 text-primary-700',
  高能: 'bg-accent-100 text-accent-900',
  焦点: 'bg-secondary-100 text-secondary-900',
  爆款: 'bg-primary-500 text-background-50',
  热门: 'bg-secondary-200 text-secondary-900',
  火料: 'bg-accent-500 text-background-950',
};

export default function FlashFeed() {
  return (
    <section id="flash" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-8 h-px bg-primary-500" />
                <span className="text-xs md:text-sm font-semibold tracking-[0.28em] text-primary-700">
                  LIVE FEED
                </span>
              </div>
              <h3 className="font-heading font-black text-foreground-950 text-2xl md:text-4xl leading-tight">
                实时快讯流
              </h3>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                按时间顺序滚动的最新高能看点，每条都标了当下的热度位置，滑一遍就知道正在发生什么。
              </p>

              <div className="mt-8 p-6 rounded-lg bg-background-100 border border-background-200/80">
                <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot" />
                  实时脉搏
                </div>
                <div className="mt-5 space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-foreground-600">过去 1 小时更新</span>
                    <span className="font-heading font-black text-foreground-950 text-xl">36</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-foreground-600">进行中话题</span>
                    <span className="font-heading font-black text-foreground-950 text-xl">12</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-foreground-600">热度峰值</span>
                    <span className="font-heading font-black text-primary-600 text-xl">98.6</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col">
              {flashItems.map((item, index) => (
                <div key={item.time} className="flex gap-4 md:gap-6">
                  <div className="hidden md:block w-16 shrink-0 pt-1 text-right text-sm font-semibold text-foreground-500">
                    {item.time}
                  </div>
                  <div className="flex flex-col items-center shrink-0">
                    <span className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100 mt-1.5" />
                    {index !== flashItems.length - 1 && (
                      <span className="flex-1 w-px bg-background-300 my-3 min-h-[40px]" />
                    )}
                  </div>
                  <div className="flex-1 pb-8 md:pb-10">
                    <div className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6 hover:border-primary-300 transition-colors">
                      <div className="flex flex-wrap items-center gap-3 mb-3">
                        <span
                          className={`px-2.5 py-1 rounded-full text-xs font-semibold ${
                            tagStyles[item.tag] ?? 'bg-background-200 text-foreground-800'
                          }`}
                        >
                          {item.tag}
                        </span>
                        <span className="md:hidden text-xs text-foreground-500">{item.time}</span>
                        <span className="ml-auto text-xs font-medium text-foreground-500">
                          {item.heat}
                        </span>
                      </div>
                      <h4 className="font-heading font-bold text-foreground-950 text-base md:text-lg leading-snug">
                        {item.title}
                      </h4>
                      <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}